import { execute, GraphQLRequest } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { GraphQLClient } from 'graphql-request';

const getUnifiedGqlUri = () => 'https://uapi.climate.com/app/graphql';
const getHeaders = () => ({
  'x-http-caller-id': process.env.npm_package_name || '',
  'x-http-caller-version': process.env.npm_package_version || '',
  'content-type': 'application/json',
});

const uapiLink = new HttpLink({
  uri: getUnifiedGqlUri(),
  headers: getHeaders(),
  credentials: 'include',
});

export const uapiConnection = (request: GraphQLRequest) =>
  new Promise((resolve, reject) => {
    execute(uapiLink, request).subscribe({
      next: (data) => resolve(data),
      error: (error) => reject(error),
    });
  });

let uapiGraphqlClient: GraphQLClient | undefined;
export const getGraphqlClient = () => {
  if (!uapiGraphqlClient) {
    uapiGraphqlClient = new GraphQLClient(getUnifiedGqlUri(), {
      credentials: 'include',
      headers: getHeaders(),
    });
  }

  return uapiGraphqlClient;
};
